import http from "../../http";

/** 发票申请 — /resident/api/resident/houseInvoice */
const BASE = "/resident/api/resident/houseInvoice";

export default {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  statusCount(r) {
    return http.get(`${BASE}/statusCount`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  issue(r) {
    return http.tip.payload(`${BASE}/issue`, r);
  },
  reject(r) {
    return http.payload(`${BASE}/reject`, r);
  },
};
